import { getFilingTypes, getFilingTags, getFilingSummary } from './http/quant-ws/v1/filings';
import type { QueryObserverOptions } from '@tanstack/react-query';

export function filingTypesQuery(): QueryObserverOptions<string[], Error> {
    return {
        queryKey: ['filings', 'types'],
        queryFn: () => getFilingTypes(),
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes
    };
}

export function filingTagsQuery(): QueryObserverOptions<string[], Error> {
    return {
        queryKey: ['filings', 'tags'],
        queryFn: () => getFilingTags(),
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes
    };
}

export function filingSummaryQuery(filingId: string): QueryObserverOptions<string, Error> {
    return {
        queryKey: ['filings', 'summary', filingId],
        queryFn: () => getFilingSummary(filingId),
        staleTime: 30 * 60 * 1000, // 30 minutes - summaries don't change
        gcTime: 60 * 60 * 1000, // 1 hour
        enabled: !!filingId,
    };
}
